import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/dvmf-2023/sponsors/ben-folds.jpg',
      link: 'https://usuo.org/give',
      alt: 'Donate to USUO',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/grandeur-peak.jpg',
      alt: 'Grandeur Peaks',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/noorda-season.jpg',
      link: 'https://uvu.edu/noorda',
      alt: 'The NOORDA',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/Classical-89.jpg',
      link: 'https://www.classical89.org',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/george-dolores-eccles.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'Eccles Foundation',
      class: 'webFormat',
    },
    // {
    //   image: '/dvmf-2023/sponsors/ghostlight.jpg',
    //   link: 'https://soundcloud.com/utahsymphony',
    //   alt: 'Ghostlight Podcast',
    //   class: 'webFormat',
    // },
    // {
    //   image: '/dvmf-2023/sponsors/education.jpg',
    //   link: 'https://www.deervalleymusicfestival.org/',
    //   alt: 'DVMF Education information',
    //   class: 'webFormat',
    // },
    // {
    //   image: '/dvmf-2023/sponsors/holland-hart.jpg',
    //   link: 'https://www.hollandhart.com/',
    //   alt: 'Holland & Hart',
    //   class: 'webFormat',
    // },
    // {
    //   image: '/dvmf-2023/sponsors/share-us.jpg',
    //   alt: 'Utah Symphony social media call out',
    //   class: 'webFormat',
    // },
    {
      image: '/dvmf-2023/sponsors/st-regis.jpg',
      link: 'https://www.marriott.com/en-us/hotels/slcxr-the-st-regis-deer-valley/overview/',
      alt: 'St. Regis',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/summit-sothebys.jpg',
      link: 'https://www.summitsothebysrealty.com',
      alt: 'Summit Sothebys',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/us-films.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'USUO Films',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/us-pops-series.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'USUO Pops Series',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/us-thank-you.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'USUO Thank You',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2023/sponsors/zions-bank.jpg',
      link: 'https://www.zionsbank.com',
      alt: 'Zions Bank',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
